export const FETCH_USER_VALIDATION = "FETCH_USER_VALIDATION";
export const FETCH_USER_VALIDATION_SUCCESS = "FETCH_USER_VALIDATION_SUCCESS";
export const RESET_USER_VALIDATION = "RESET_USER_VALIDATION";